import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from "vue-property-decorator";
let ProgressButton = class ProgressButton extends Vue {
    click() {
    }
    get computedVariant() {
        if (!this.showStates) {
            return this.variant;
        }
        return this.task.isSuccessful ? 'success' : this.variant;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ProgressButton.prototype, "showProgress", void 0);
__decorate([
    Prop({ type: String, default: 'primary' })
], ProgressButton.prototype, "variant", void 0);
__decorate([
    Prop({ type: String, default: 'button' })
], ProgressButton.prototype, "type", void 0);
__decorate([
    Prop({ type: Object })
], ProgressButton.prototype, "task", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ProgressButton.prototype, "showStates", void 0);
__decorate([
    Emit()
], ProgressButton.prototype, "click", null);
ProgressButton = __decorate([
    Component({})
], ProgressButton);
export default ProgressButton;
